import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import QuizPage from './pages/QuizPage';
import ResultPage from './pages/ResultPage';
import BookmarkedPage from './pages/BookmarkedPage';
import SettingsPage from './pages/SettingsPage';
import AboutPage from './pages/AboutPage';
import OfflinePage from './pages/OfflinePage';
import Header from './components/Header';
import { QuizProvider } from './context/QuizContext';
import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import './i18n/i18n'; // Initialize i18n

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <LanguageProvider>
          <QuizProvider>
            <Header />
            <div className="App">
              <Routes>
                {/* Base routes for English (default) */}
                <Route path="/" element={<HomePage />} />
                <Route path="/quiz/:state/:id/:name" element={<QuizPage />} />
                <Route path="/result" element={<ResultPage />} />
                <Route path="/bookmarked" element={<BookmarkedPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/offline" element={<OfflinePage />} />

                {/* Spanish routes */}
                <Route path="/es" element={<HomePage />} />
                <Route path="/es/quiz/:state/:id/:name" element={<QuizPage />} />
                <Route path="/es/result" element={<ResultPage />} />
                <Route path="/es/bookmarked" element={<BookmarkedPage />} />
                <Route path="/es/settings" element={<SettingsPage />} />
                <Route path="/es/about" element={<AboutPage />} />
                <Route path="/es/offline" element={<OfflinePage />} />

                {/* Portuguese routes */}
                <Route path="/pt" element={<HomePage />} />
                <Route path="/pt/quiz/:state/:id/:name" element={<QuizPage />} />
                <Route path="/pt/result" element={<ResultPage />} />
                <Route path="/pt/bookmarked" element={<BookmarkedPage />} />
                <Route path="/pt/settings" element={<SettingsPage />} />
                <Route path="/pt/about" element={<AboutPage />} />
                <Route path="/pt/offline" element={<OfflinePage />} />

                {/* Handle /en/ prefix by redirecting to non-prefixed routes */}
                <Route path="/en/*" element={<Navigate to="/*" replace />} />

                {/* 404 Fallback */}
                <Route path="*" element={<div>404 Not Found</div>} />
              </Routes>
            </div>
          </QuizProvider>
        </LanguageProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
